import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import img from "../../../../assets/fons/background_clar.jpg";
import svg from "../../../../assets/simbols/mascara-activitats-1.svg";
import { ReactComponent as Simbol1 } from "../../../../assets/simbols/simbol3.svg";
import { ReactComponent as Simbol2 } from "../../../../assets/simbols/simbol2.svg";
import { ReactComponent as Simbol3 } from "../../../../assets/simbols/simbol1.svg";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../components/CustomButton";
import { animated, useSpring } from "react-spring";

const ProtagonistaElement = ({ protagonista, index }) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const swing1 = useSpring({
        from: { rotate: "-2deg" },
        to: { rotate: "8deg" },
        loop: { reverse: true },
        config: { duration: 1000 },
    });
    const swing2 = useSpring({
        from: { rotate: "-4deg" },
        to: { rotate: "6deg" },
        loop: { reverse: true },
        config: { duration: 1000 },
    });
    const swing3 = useSpring({
        from: { rotate: "14deg" },
        to: { rotate: "26deg" },
        loop: { reverse: true },
        config: { duration: 1000 },
    });

    const sanefa = () => {
        switch (index % 3) {
            case 0:
                return (
                    <animated.div style={swing1} className={classes.simbol1}>
                        <Simbol1 className={classes.simbolSvg} />
                    </animated.div>
                );

            case 1:
                return (
                    <animated.div style={swing2} className={classes.simbol2}>
                        <Simbol2 className={classes.simbolSvg} />
                    </animated.div>
                );

            case 2:
                return (
                    <animated.div style={swing3} className={classes.simbol3}>
                        <Simbol3 className={classes.simbolSvg} />
                    </animated.div>
                );

            default:
                break;
        }
    };

    return (
        <Box className={classes.main}>
            <Box className={classes.imgWrap}>
                <img
                    src={"https://api.merollabergueda.com/public/storage/" + protagonista.foto}
                    alt={protagonista.nom}
                    className={index % 2 === 0 ? classes.img : classes.img2}
                />
                {sanefa()}
            </Box>
            <Box className={classes.textBlock}>
                <Typography variant="h3" pr={2}>
                    {protagonista.nom}
                </Typography>
                <Typography>{i18n.language === "ca" ? protagonista.descripcio : protagonista.descripcio_es}</Typography>
            </Box>
            <Box className={classes.cta}>
                <CustomButton title={t("video")} fullWidth onClick={() => window.open(protagonista.link)} />
            </Box>
        </Box>
    );
};

export default ProtagonistaElement;

const useStyles = makeStyles((theme) => ({
    main: {
        padding: 30,
        background: `url(${img})`,
        marginBottom: 80,
        borderRadius: 30,
        display: "flex",
        gap: theme.spacing(5),
        alignItems: "center",
        flexWrap: "wrap",
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            textAlign: "center",
        },
    },
    simbol1: {
        position: "absolute",
        top: 60,
        left: 20,
        width: 60,
        fill: theme.color.secondary,
        transform: "scaleX(-1)",
        zIndex: 100,
    },
    simbol2: {
        position: "absolute",
        bottom: 20,
        left: 20,
        width: 60,
        fill: theme.color.primary,
        zIndex: 100,
    },
    simbol3: {
        position: "absolute",
        bottom: 10,
        left: -15,
        width: 110,
        fill: theme.color.secondary,
        transform: "rotate(20deg)",
        zIndex: 100,
    },
    imgWrap: {
        width: 305,
        height: 300,
        zIndex: 0,
        position: "relative",
        mask: `url(${svg})`,
        maskSize: "cover",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        [theme.breakpoints.down("md")]: {
            width: "100%",
            height: "auto",
            maxWidth: "100%",
            aspectRatio: "1 / 1",
        },
    },
    img: {
        width: "100%",
        height: "100%",
        zIndex: 0,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: "auto",
        objectFit: "cover",
    },
    img2: {
        width: "100%",
        height: "100%",
        zIndex: 0,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: "auto",
        objectFit: "cover",
    },
    textBlock: {
        flex: "1 1 200px",
        minWidth: 260,
    },
    cta: {
        flex: "0 0 220px",
        display: "flex",
        justifyContent: "center",
        [theme.breakpoints.down("md")]: {
            width: "100%",
            flexBasis: "100%",
        },
    },
    simbolSvg: {
        width: "100%",
        height: "100%",
        fill: "inherit",
    },
}));
